var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-box"},[_c('h2',{staticClass:"title"},[_vm._v("抱歉，页面未找到")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.go()}}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }